<template>
  <div class="splash-container">
    <!-- Animated background elements -->
    <div class="bg-elements">
      <div class="sphere sphere-1"></div>
      <div class="sphere sphere-2"></div>
      <div class="sphere sphere-3"></div>
      <div class="sphere sphere-4"></div>
    </div>

    <!-- Background -->
    <div class="splash-background"></div>

    <!-- Content wrapper -->
    <div class="content-wrapper">
      <!-- Left side - Text content -->
      <div class="left-content">
        <div class="subtitle-label">Introduciendo nueva tecnología</div>
        <h1 class="splash-title">
          Rutas <span class="highlight">Alpezzi TP</span>
        </h1>
        <p class="splash-description">Sistema de visualización y seguimiento en tiempo real de rutas de transporte.</p>

        <div class="button-group">
          <button class="btn-map" @click="goToMap">Ir a  Mapa</button>
        </div>
      </div>

      <!-- Right side - Bus image -->
      <div class="right-content">
        <div class="bus-container">
          <img src="@/assets/bus.webp" alt="Bus Alpezzi" class="bus-image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goToMap = () => {
  router.push({ name: 'map' });
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.splash-container {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0f1419 0%, #1a1f2e 50%, #2d1b4e 100%);
}

.splash-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.1) 0%, transparent 50%);
  z-index: 1;
}

.bg-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
}

.sphere {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.1));
  animation: float 6s ease-in-out infinite;
}

.sphere-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  right: 15%;
  animation-delay: 0s;
}

.sphere-2 {
  width: 60px;
  height: 60px;
  top: 60%;
  right: 8%;
  animation-delay: 2s;
}

.sphere-3 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 4s;
}

.sphere-4 {
  width: 50px;
  height: 50px;
  bottom: 20%;
  right: 40%;
  animation-delay: 3s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-30px);
  }
}

.content-wrapper {
  position: relative;
  z-index: 10;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
  gap: 80px;
}

.left-content {
  flex: 1;
  animation: slideInLeft 0.8s ease-out;
}

.subtitle-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.splash-title {
  font-size: 4rem;
  font-weight: 700;
  color: white;
  margin: 0 0 20px 0;
  line-height: 1.2;
  letter-spacing: -1px;
}

.splash-title .highlight {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.splash-description {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 50px 0;
  line-height: 1.6;
  max-width: 500px;
}

.button-group {
  display: flex;
  gap: 20px;
  animation: slideInUp 0.8s ease-out 0.2s both;
}

.btn-map {
  padding: 12px 28px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: white;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: capitalize;
  letter-spacing: 0.5px;
}

.btn-map:hover {
  border-color: white;
  color: white;
}

.right-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: slideInRight 0.8s ease-out;
}

.bus-container {
  position: relative;
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 1000px;
}

.bus-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3));
  animation: rotateIn 1s ease-out;
  transform-origin: center;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes rotateIn {
  from {
    opacity: 0;
    transform: rotateY(-20deg) scale(0.8);
  }
  to {
    opacity: 1;
    transform: rotateY(0) scale(1);
  }
}

@media (max-width: 1200px) {
  .content-wrapper {
    padding: 0 40px;
    gap: 60px;
  }

  .splash-title {
    font-size: 3rem;
  }

  .bus-container {
    height: 300px;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
    padding: 40px 20px;
    gap: 40px;
    height: auto;
    min-height: 100vh;
    justify-content: center;
  }

  .left-content {
    text-align: center;
  }

  .splash-title {
    font-size: 2.2rem;
  }

  .splash-description {
    font-size: 1rem;
  }

  .button-group {
    justify-content: center;
  }

  .right-content {
    width: 100%;
  }

  .bus-container {
    height: 250px;
  }

  .sphere {
    display: none;
  }
}

@media (max-width: 480px) {
  .splash-title {
    font-size: 1.8rem;
  }

  .button-group {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}
</style>
